module.exports = __webpack_public_path__ + "static/media/Tobeloaded.7f90fdaf.png";